import { useAuroraStore } from '../../store/auroraStore'
import { ritualsForDate, type Ritual } from '../../store/selectors'
import { toggleRitual } from '../../lib/planEdit'

/**
 * The things woven into the day rather than scheduled into it.
 *
 * Rituals are not blocks and must not look like them: no card, no domain
 * colour, no start button, no minutes competing for attention. They are a quiet
 * list you can tick if you did the thing, and they cost nothing if you never
 * open this panel — which is the point, because they happen at breakfast and in
 * the car, not at an appointed time.
 */
export function RitualsPanel({ date }: { date: string }) {
  const rituals = useAuroraStore((s: any) => ritualsForDate(s, date)) as Ritual[]

  if (!rituals.length) return null

  const done = rituals.filter((r) => r.done).length

  return (
    <section className="section rituals">
      <div className="section-head">
        <h2 className="section-title">Woven in today</h2>
        {done > 0 && (
          <span className="rituals-count tnum" aria-hidden="true">
            {done} of {rituals.length}
          </span>
        )}
      </div>

      <ul className="rituals-list">
        {rituals.map((r) => (
          <li key={r.key}>
            <button
              className={`ritual${r.done ? ' is-done' : ''}`}
              onClick={() => toggleRitual(date, r.key, r.title, !r.done)}
              aria-pressed={r.done}
            >
              <span className="ritual-box" aria-hidden="true">
                {r.done && <CheckIcon />}
              </span>
              <span className="ritual-text">
                <span className="ritual-title">{r.title}</span>
                {r.description && <span className="ritual-desc">{r.description}</span>}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </section>
  )
}

const CheckIcon = () => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M4 12.5l5 5L20 6.5" />
  </svg>
)
